import type { SettingsState } from '../context/SettingsContext';

/** App Lock (PIN) and Fingerprint Unlock are mutually exclusive. */
export function normalizeSecuritySettings(
  current: SettingsState['security'],
  patch: Partial<SettingsState['security']> = {}
): SettingsState['security'] {
  const merged = { ...current, ...patch };

  if (patch.biometric === true) {
    merged.appLock = false;
  }
  if (patch.appLock === true) {
    merged.biometric = false;
  }

  if (merged.biometric && merged.appLock) {
    merged.biometric = false;
  }

  return merged;
}

export function isAppLockActive(security: SettingsState['security']): boolean {
  return security.appLock || security.biometric;
}

export function canUseBiometricUnlock(security: SettingsState['security']): boolean {
  return security.biometric;
}

export function shouldShowPinOnLockScreen(security: SettingsState['security']): boolean {
  return security.appLock && !!security.pinCode;
}

export function shouldShowPinSetup(security: SettingsState['security']): boolean {
  return security.appLock;
}
